// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(value) {
  switch (value) {
    case "AllocationRadius" :
    case "allocation_radius" :
        return /* AllocationRadius */0;
    case "DryRun" :
    case "dry_run" :
        return /* DryRun */1;
    case "MapsDistance" :
    case "maps_distance" :
        return /* MaxDryRun */2;
    default:
      return ErrorUtils$Catalyst.raiseError("FilterType.res", "Not a valid filter", value);
  }
}

function toString(value) {
  switch (value) {
    case /* AllocationRadius */0 :
        return "AllocationRadius";
    case /* DryRun */1 :
        return "DryRun";
    case /* MaxDryRun */2 :
        return "MapsDistance";
    
  }
}

function toDisplayString(value) {
  switch (value) {
    case /* AllocationRadius */0 :
        return "Allocation Radius";
    case /* DryRun */1 :
        return "Dry Run Ratio";
    case /* MaxDryRun */2 :
        return "Max Dry Run";
    
  }
}

export {
  fromString ,
  toString ,
  toDisplayString ,
  
}
/* No side effect */
